import { render, staticRenderFns } from "./diet-advice.vue?vue&type=template&id=0d9a480d&scoped=true&"
import script from "./diet-advice.vue?vue&type=script&lang=js&"
export * from "./diet-advice.vue?vue&type=script&lang=js&"
import style0 from "./diet-advice.vue?vue&type=style&index=0&id=0d9a480d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d9a480d",
  null
  
)

export default component.exports